// extracted by mini-css-extract-plugin
module.exports = {"radio":"radiobutton_radio__MA2F_"};